import React, { memo, useRef, useEffect } from "react";
import { Text } from '@react-three/drei';
import * as THREE from "three";

// 参考
// https://medium.com/@astatsuya/three-js%E3%81%A7%E5%B8%B8%E3%81%AB%E6%AD%A3%E9%9D%A2%E3%82%92%E5%90%91%E3%81%8F%E9%95%B7%E6%96%B9%E5%BD%A2%E3%81%AE%E6%96%87%E5%AD%97%E3%83%A9%E3%83%99%E3%83%AB%E3%82%92%E6%8F%8F%E7%94%BB%E3%81%99%E3%82%8B-fa606ed6752

/*
function hex2rgba (hex, alpha = 1) {
  // ロングバージョンの場合（例：#FF0000）
  let r = hex.match(/^#([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})$/i)
  let c = null
  if (r) {
    c = r.slice(1,4).map(function(x) { return parseInt(x, 16) })
  }
  // ショートバージョンの場合（例：#F00）
  r = hex.match(/^#([0-9a-f])([0-9a-f])([0-9a-f])$/i)
  if (r) {
    c = r.slice(1,4).map(function(x) { return 0x11 * parseInt(x, 16) })
  }
  // 該当しない場合は、nullを返す.
  if (!c) {
    return null
  }
  return `rgba(${c[0]}, ${c[1]}, ${c[2]}, ${alpha})`
}
*/


const createCanvasForTexture = (canvasWidth, canvasHeight, text, fontSize, textColor) => {
  // 貼り付けるcanvasを作成。
  const canvasForText = document.createElement("canvas");
  const ctx = canvasForText.getContext("2d");
  ctx.canvas.width = canvasWidth*2; // 小さいと文字がぼやける
  ctx.canvas.height = canvasHeight*2; // 小さいと文字がぼやける
  // 透過率50%の青背景を描く
  ctx.fillStyle = "rgba(255, 255, 255, 0)";
  ctx.fillRect(0, 0, ctx.canvas.width, ctx.canvas.height);
  
  ctx.fillStyle = textColor;
  ctx.font = `${fontSize}px serif`;
  ctx.fillText(
    text,
    // x方向の余白/2をx方向開始時の始点とすることで、横方向の中央揃えをしている。
    (canvasWidth*2 - ctx.measureText(text).width) / 2,
    // y方向のcanvasの中央に文字の高さの半分を加えることで、縦方向の中央揃えをしている。
    canvasHeight*2 / 2 + ctx.measureText(text).actualBoundingBoxAscent / 2
  );
  return canvasForText;
};

export const TextObject = memo(({ text, vpoint, color }) => {
  const ref = useRef();
  useEffect(() => {
    ref.current.position.set(vpoint.x, vpoint.y, vpoint.z-10);
  }, [vpoint]);

  const texture = new THREE.CanvasTexture(
    createCanvasForTexture(100, 15, text, 24, color)
  );

  return (
    <sprite ref={ref} scale={[100, 15, 1]} renderOrder={1}>
      <spriteMaterial attach="material" map={texture} depthTest={false}/>
    </sprite>
  );
});


/*
export const TextObject = memo(({ text, vpoint, color, degree}) => {
  
  return (
    <Text
      position={[vpoint.x, vpoint.y, vpoint.z]}
      rotation={degree}
      fontSize={15}
      color={color}
    >
      {text}
    </Text>
  )
})
*/